import { Alert, Link, Typography } from '@mui/material'

import { ReferenceTier } from '@/lib/apollo/query/get-applicant'
import { referenceTierStylesMap } from '@/utils/tier'

const controlBannerCopy: Record<string, { bannerText: string; linkHref: string }> = {
  [ReferenceTier.selfServe]: {
    bannerText:
      'This is a Goodlord Control (self-serve) application. Agents should be guided to complete any administrative tasks they can complete themselves.',
    linkHref:
      'https://docs.google.com/spreadsheets/d/10K8Ie2gy2cCCMsdV7Nq6pnFS7vBJXIpjRGSUZRGH1tw/edit?usp=sharing',
  },
  [ReferenceTier.selfServeStudent]: {
    bannerText:
      'This is a Goodlord Control Student (self-serve-student) reference. Agents should be guided to complete any administrative tasks they can complete themselves.',
    linkHref:
      'https://docs.google.com/spreadsheets/d/10K8Ie2gy2cCCMsdV7Nq6pnFS7vBJXIpjRGSUZRGH1tw/edit?gid=650956815#gid=650956815',
  },
}

interface GoodlordControlBannerProps {
  referenceTier: ReferenceTier
}

const GoodlordControlBanner = ({ referenceTier }: GoodlordControlBannerProps) => {
  const { backgroundColor, color: textColor } = referenceTierStylesMap[referenceTier]
  const { bannerText, linkHref } = controlBannerCopy[referenceTier]

  return (
    <Alert
      sx={{
        backgroundColor,
        borderRadius: 0,
        color: textColor,
        '& .MuiAlert-icon': {
          color: textColor,
        },
      }}
      severity="warning"
      variant="filled"
    >
      <Typography color={textColor}>
        {bannerText}{' '}
        <Link
          href={linkHref}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: textColor, textDecorationColor: textColor }}
        >
          Here is a list of what they can and can&apos;t do themselves
        </Link>
        .
      </Typography>
    </Alert>
  )
}

export default GoodlordControlBanner
